import { render, staticRenderFns } from "./AdminProviders.vue?vue&type=template&id=3eba0906"
import script from "./AdminProviders.vue?vue&type=script&lang=js"
export * from "./AdminProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports